import React from "react";
import { Modal, Button, Typography, Divider } from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  BankOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

const EnhancedConfirmationAlert = ({
  visible,
  message,
  onConfirm,
  onCancel,
  title = "Payment Confirmation",
  loading = false,
  bankDetails = null,
  consultantName = "",
  amount = 0,
  primaryColor = "#A40165",
}) => {
  return (
    <Modal
      title={
        <div className="flex items-center">
          <BankOutlined
            style={{
              fontSize: "20px",
              color: primaryColor,
              marginRight: "12px",
            }}
          />
          <span style={{ color: primaryColor, fontWeight: 500 }}>{title}</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={500}
      centered
      bodyStyle={{ padding: "24px" }}
    >
      {/* Consultant and Amount Info */}
      {(consultantName || amount > 0) && (
        <div className="mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100">
          {consultantName && (
            <div className="flex items-center mb-3">
              <Text strong style={{ fontSize: "16px" }}>
                Payment to: {consultantName}
              </Text>
            </div>
          )}
          {amount > 0 && (
            <div className="flex items-center">
              <Text>
                Amount: <Text strong>₹{amount}</Text>
              </Text>
            </div>
          )}
        </div>
      )}

      {/* Bank Details Summary */}
      {bankDetails && (
        <div className="mb-6">
          <div className="flex items-center mb-2">
            <BankOutlined style={{ color: primaryColor, marginRight: "8px" }} />
            <Text strong>Bank Account Details</Text>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
            <div className="grid grid-cols-2 gap-2">
              <Text type="secondary">Account Holder:</Text>
              <Text strong>{bankDetails.accountHolderName}</Text>

              <Text type="secondary">Bank Name:</Text>
              <Text strong>{bankDetails.bankName}</Text>

              <Text type="secondary">Account Number:</Text>
              <Text strong>{bankDetails.accountNumber}</Text>

              <Text type="secondary">IFSC Code:</Text>
              <Text strong>{bankDetails.ifscCode}</Text>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Message */}
      <div className="mb-6 text-center">
        <div className="flex items-center justify-center mb-4">
          <div
            className="flex items-center justify-center w-12 h-12 rounded-full"
            style={{ backgroundColor: `${primaryColor}15` }}
          >
            <InfoCircleOutlined
              style={{ fontSize: "24px", color: primaryColor }}
            />
          </div>
        </div>
        <Title level={5} style={{ marginBottom: "16px" }}>
          {message || "Have you made payment to this consultant?"}
        </Title>
        <Text type="secondary">
          Once confirmed, the status will be updated to "Redeemed" and cannot be
          changed.
        </Text>
      </div>

      <Divider style={{ margin: "16px 0" }} />

      {/* Action Buttons */}
      <div className="flex justify-center gap-4">
        <Button
          size="large"
          onClick={onCancel}
          icon={<CloseCircleFilled />}
          style={{ minWidth: "120px" }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          size="large"
          onClick={onConfirm}
          loading={loading}
          icon={<CheckCircleFilled />}
          style={{
            minWidth: "120px",
            backgroundColor: primaryColor,
            borderColor: primaryColor,
          }}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default EnhancedConfirmationAlert;
